const validateUrl = (url) => {
  let newUrl = url.includes('http') ? url : `http://${url}`;
  return newUrl;
};

export default validateUrl;